import { render, staticRenderFns } from "./RedirectionsList.vue?vue&type=template&id=1c1a0aba&scoped=true&"
import script from "./RedirectionsList.vue?vue&type=script&lang=js&"
export * from "./RedirectionsList.vue?vue&type=script&lang=js&"
import style0 from "./RedirectionsList.vue?vue&type=style&index=0&id=1c1a0aba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a0aba",
  null
  
)

export default component.exports